import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';

import * as PostActions from './../store/post.actions';
import * as fromApp from '../../../store/app.reducers';
import * as fromPost from '../store/post.reducers';
import * as fromProfile from './../../store/profile.reducers';

@Component({
    selector: 'app-post-audit',
    templateUrl: './post-audit.component.html',
    styleUrls: ['./post-audit.component.scss'],
    standalone: false
})
export class PostAuditComponent implements OnInit {

  routeSubscription: Subscription;
  id: number;
  postState: Observable<fromPost.State>;
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,

  ) { }

  ngOnInit() {
    this.postState = this.store.select('post');
    this.profileState = this.store.select('profile');
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        this.id = params.id;
        this.store.dispatch(
          new PostActions.GetAudit(this.id)
        );
        this.store.dispatch(
          new PostActions.GetPostDetail({
            id: this.id
          })
        );
        this.store.dispatch(
          new PostActions.GetPostProgress({
            id: this.id
          })
        );
      }
    );
  }

}
